function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#C3C3C3;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-179.856 -91.391)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(179.856 91.391)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,0.2h2.3l3.5,6h0.1l3.5-6h2.3l-4.8,8v5.2h-2V8.2L0,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M28.7,6.8c0,1.3-0.2,2.5-0.8,3.6c-0.5,1-1.2,1.8-2.1,2.3c-1.9,1.1-4.2,1.1-6.1,0c-0.9-0.6-1.7-1.4-2.1-2.3 c-1-2.3-1-5,0-7.3c0.5-1,1.2-1.8,2.1-2.3c1.9-1.1,4.2-1.1,6.1,0c0.9,0.6,1.7,1.4,2.1,2.3C28.4,4.3,28.7,5.5,28.7,6.8z M26.7,6.8 c0-0.9-0.1-1.9-0.5-2.7c-0.3-0.7-0.8-1.3-1.4-1.7c-1.3-0.8-2.8-0.8-4.1,0c-0.6,0.4-1.1,1-1.4,1.7c-0.7,1.8-0.7,3.7,0,5.5 c0.3,0.7,0.8,1.3,1.4,1.7c1.3,0.8,2.8,0.8,4.1,0c0.6-0.4,1.1-1,1.4-1.7C26.5,8.7,26.7,7.7,26.7,6.8L26.7,6.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M44,0.2h2v8.7c0,0.9-0.2,1.7-0.7,2.5c-0.4,0.7-1.1,1.3-1.8,1.7c-1.8,0.8-3.8,0.8-5.5,0 c-0.8-0.4-1.4-1-1.8-1.7c-0.4-0.7-0.7-1.6-0.7-2.5V0.2h2v8.6c0,0.6,0.1,1.1,0.4,1.6c0.3,0.5,0.7,0.8,1.1,1.1 c1.1,0.5,2.4,0.5,3.5,0c0.5-0.2,0.9-0.6,1.1-1.1c0.3-0.5,0.4-1,0.4-1.6L44,0.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M53.3,13.4V0.2H58c0.9,0,1.8,0.2,2.6,0.5c0.6,0.3,1.2,0.8,1.5,1.5c0.3,0.7,0.5,1.4,0.5,2.2 c0,0.7-0.2,1.5-0.5,2.1c-0.3,0.6-0.9,1.1-1.5,1.4c-0.8,0.4-1.7,0.5-2.6,0.5h-3.6V6.7h3.4c0.5,0,1.1-0.1,1.6-0.3 c0.4-0.2,0.7-0.4,0.9-0.8c0.2-0.4,0.3-0.8,0.3-1.3c0-0.5-0.1-0.9-0.3-1.3c-0.2-0.4-0.5-0.7-0.9-0.8c-0.5-0.2-1.1-0.3-1.6-0.3h-2.5 v11.5L53.3,13.4z M59.8,7.5l3.3,6h-2.3l-3.2-6H59.8z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(256.778 91.572)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.8,13.4L0,0.2h3.1l2.2,9.2h0.1l2.4-9.2h2.6l2.4,9.2h0.1l2.2-9.2h3.1l-3.8,13.2h-2.7L9.1,4.8H9l-2.5,8.7 L3.8,13.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M35.5,6.8c0,1.3-0.2,2.5-0.8,3.7c-0.5,1-1.3,1.8-2.2,2.3c-2,1.1-4.4,1.1-6.3,0c-0.9-0.5-1.7-1.4-2.2-2.3 c-1.1-2.3-1.1-5,0-7.4c0.5-1,1.3-1.8,2.2-2.3c2-1.1,4.4-1.1,6.3,0c0.9,0.5,1.7,1.3,2.2,2.3C35.2,4.3,35.5,5.5,35.5,6.8z M32.6,6.8 c0-0.8-0.1-1.6-0.4-2.4C32,3.8,31.6,3.3,31,3c-1.1-0.7-2.5-0.7-3.5,0c-0.5,0.4-0.9,0.9-1.2,1.5c-0.6,1.5-0.6,3.2,0,4.7 c0.2,0.6,0.6,1.1,1.2,1.5c1.1,0.7,2.5,0.7,3.5,0c0.5-0.4,0.9-0.9,1.2-1.5C32.5,8.4,32.6,7.6,32.6,6.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M49.1,4c0-0.5-0.3-0.9-0.7-1.2c-0.5-0.3-1-0.5-1.6-0.4c-0.4,0-0.8,0.1-1.2,0.2c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.2,0.2-0.3,0.5-0.2,0.8c0,0.2,0,0.4,0.2,0.6c0.1,0.2,0.3,0.3,0.5,0.5C45.5,5,45.7,5.1,46,5.2c0.3,0.1,0.5,0.2,0.8,0.2L48,5.8 C48.5,5.9,49,6,49.5,6.3c0.5,0.2,0.9,0.5,1.3,0.8c0.3,0.3,0.6,0.7,0.8,1.1c0.2,0.5,0.3,1,0.3,1.5c0,0.7-0.2,1.5-0.6,2.1 c-0.4,0.6-1.1,1.1-1.8,1.4c-0.9,0.3-1.8,0.5-2.8,0.5c-1,0-1.9-0.1-2.8-0.5c-0.7-0.3-1.4-0.8-1.9-1.5c-0.5-0.7-0.7-1.5-0.7-2.4h2.7 c0,0.4,0.1,0.8,0.4,1.1c0.2,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.2,1.3,0.2c0.4,0,0.8-0.1,1.2-0.2c0.3-0.1,0.6-0.3,0.8-0.6 c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.5-0.3-0.8c-0.2-0.2-0.5-0.4-0.8-0.5c-0.4-0.2-0.8-0.3-1.2-0.4l-1.4-0.4 c-1-0.2-1.9-0.6-2.6-1.3c-0.7-0.6-1-1.5-1-2.3c0-0.8,0.2-1.5,0.6-2.1c0.5-0.6,1.1-1.1,1.8-1.4C45,0.2,45.9,0,46.8,0 c0.9,0,1.8,0.1,2.6,0.5c0.7,0.3,1.3,0.8,1.7,1.4c0.4,0.6,0.6,1.3,0.6,2.1L49.1,4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58.2,13.4V0.2H61v5.5h5.7V0.2h2.8v13.2h-2.8V8H61v5.5H58.2z"
})));

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.4 13.8",
    style: {
      enableBackground: "new 0 0 146.4 13.8"
    },
    xmlSpace: "preserve",
    height: "14px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.951a9ce1d7757aa342af155b32428720.svg";
export { ForwardRef as ReactComponent };